import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AccountDetails from './AccountDetails';

function Header() {
    const [isDarkBackground, setIsDarkBackground] = useState(false);
    const [isSticky, setIsSticky] = useState(false); // Nuovo stato per gestire la classe sticky
    const [locationData, setLocationData] = useState({ city: '', country: '' }); // Stato per memorizzare la posizione
    const location = useLocation();

    useEffect(() => {
        // Funzione per ottenere le coordinate con l'API di geolocalizzazione HTML5
        const fetchLocation = async () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(async (position) => {
                    const { latitude, longitude } = position.coords;

                    // Usa Nominatim per convertire le coordinate in città e stato
                    try {
                        const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=10&addressdetails=1`);
                        const data = await response.json();
                        const city = data.address.city || data.address.town || data.address.village;
                        const country = data.address.country_code.toUpperCase();
                        setLocationData({ city, country });
                    } catch (error) {
                        console.error('Errore nel recuperare la posizione:', error);
                    }
                });
            } else {
                console.error('Geolocalizzazione non supportata dal browser.');
            }
        };

        fetchLocation(); // Richiama la funzione per ottenere la posizione

        const checkBackground = () => {
            const elements = document.querySelectorAll('.check-back-ground');
            elements.forEach(element => {
                const rect = element.getBoundingClientRect();
                if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
                    if (element.classList.contains('dark-background')) {
                        setIsDarkBackground(true);
                    } else {
                        setIsDarkBackground(false);
                    }
                }
            });
        };

        const handleScroll = () => {
            if (window.scrollY > 0) {
                setIsSticky(true); // Quando l'utente scorre, rendi l'header sticky
            } else {
                setIsSticky(false); // Se non c'è scroll, rimuovi lo sticky
            }
            checkBackground();
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [location]);

    const getPageTitle = () => {
        const pathname = location.pathname;
        if (pathname === '/') {
            return '';
        } else {
            return pathname.replace('/', '').replace('-', ' ').toUpperCase();
        }
    };
    return (
        <>

            <nav className="navbar navbar-expand-lg menu_two" id="sticky">
                <div className="container">
                    <Link className="navbar-brand" to="https://psicopatici.com" target="_blank">
                        <img src="https://cdn.psicopaticiservice.com/psico-1.png" srcset="https://cdn.psicopaticiservice.com/psico-1.png" alt="logo" />
                        <h2 className="page-title align-self-end">Legal</h2>
                    </Link>
                    <button className="navbar-toggler collapsed" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span className="menu_toggle">
                            <span className="hamburger">
                                <span></span>
                                <span></span>
                                <span></span>
                            </span>
                            <span className="hamburger-cross">
                                <span></span>
                                <span></span>
                            </span>
                        </span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav menu dk_menu mr-auto">
                            <li className="nav-item">
                                <a href="#" onClick={(e) => { e.preventDefault(); window.history.back(); }} className="nav-link">
                                    Torna alla pagina precedente
                                </a>
                            </li>

                            <li className="nav-item">
                                <Link to="/" className="nav-link">Legal List</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/privacy-policy" className="nav-link">Privacy Policy</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/cookie-policy" className="nav-link">Cookie Policy</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/terms-and-conditions" className="nav-link">Termini & Condizioni</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/partner-terms" className="nav-link">Termini & Condizioni Partner</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );

}


export default Header;